import React from 'react';

function DropdownGroup({ children }: { children: React.ReactNode }) {
  return <div className="py-1">{children}</div>;
}

export default DropdownGroup;
